__turbopack_context__.v({
  "crashed": "_8rAyqG_crashed",
  "details": "_8rAyqG_details",
});
